<template>
  <v-select v-model="status" :items="statusOptions"
            item-text="value" item-value="value" :label="label"
            v-bind="$attrs">
    <template v-slot:item="{ item, on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-chip small :color="item.colour" dark>{{ item.value }}</v-chip>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-chip small :color="item.colour" dark>{{ item.value }}</v-chip>
    </template>
  </v-select>
</template>

<script>
import { jobStatuses } from '../../data'

export default {
  name: 'JobStatusSelect',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Status'
    }
  },
  data() {
    return {
      statusOptions: jobStatuses
    }
  },
  computed: {
    status: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  }
}
</script>
